<div id="breadcrumb-navigation" class="breadcrumb">
  {{ labels.administration }}
  <a
    id="rangos-salariales-breadcrumb-link"
    class="breadcrumb-link selected"
    [routerLink]="['/wapi/admin/rangos-salariales']"
  >
    &nbsp;>&nbsp;{{ labels.rangoSalarialPerfil }}
  </a>
</div>

<br /><br />

<div id="rangos-salariales-main-container" class="container">
  <mat-card id="rangos-salariales-card">
    <div id="rangos-salariales-header" class="header-options">
      <div id="rangos-salariales-title" class="title">
        <div class="title-wrapper">
          <h1 class="main-title">{{ labels.rangoSalarialPerfil }}</h1>
        </div>
      </div>
      <div class="header-actions">
        <button
          mat-raised-button
          class="filter-button"
          (click)="toggleSearch()"
          matTooltip="Filtro"
        >
          <mat-icon>filter_list</mat-icon>
          FILTRO
        </button>
        <button
          mat-raised-button
          color="primary"
          class="create-button"
          (click)="openCreateModal()"
          matTooltip="{{ labels.createRangoSalarialPerfil }}"
        >
          <mat-icon>add</mat-icon>
          {{ labels.createRangoSalarialPerfil }}
        </button>
      </div>
    </div>

    <!-- Search Panel -->
    @if (showSearchPanel) {
      <div class="search-panel">
        <div class="filters-grid">
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Buscar rangos salariales</mat-label>
            <input
              matInput
              [(ngModel)]="searchQuery"
              (input)="onSearchChange($any($event.target).value)"
              placeholder="Buscar por perfil, año..."
            />
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>

          <!-- Column filters -->
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Perfil</mat-label>
            <input
              matInput
              [(ngModel)]="columnFilters.perfil"
              (input)="onColumnFilterChange('perfil', $any($event.target).value)"
              placeholder="Filtrar por perfil..."
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Año</mat-label>
            <input
              matInput
              [(ngModel)]="columnFilters.ano"
              (input)="onColumnFilterChange('ano', $any($event.target).value)"
              placeholder="Filtrar por año..."
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Mínimo</mat-label>
            <input
              matInput
              [(ngModel)]="columnFilters.minimo"
              (input)="onColumnFilterChange('minimo', $any($event.target).value)"
              placeholder="Filtrar por mínimo..."
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Máximo</mat-label>
            <input
              matInput
              [(ngModel)]="columnFilters.maximo"
              (input)="onColumnFilterChange('maximo', $any($event.target).value)"
              placeholder="Filtrar por máximo..."
            />
          </mat-form-field>
        </div>
        <button
          mat-stroked-button
          color="primary"
          (click)="clearFilters()"
          style="height: 40px; align-self: center"
        >
          <mat-icon style="margin-right: 6px">filter_alt_off</mat-icon>
          Limpiar filtros
        </button>
      </div>
    }

    <div id="rangos-salariales-table-section" class="table-container">
      @if (loading$ | async) {
        <div class="loading-container">
          <mat-spinner diameter="50"></mat-spinner>
          <p>{{ labels.loadingRangosSalariales }}</p>
        </div>
      } @else if (error$ | async) {
        <div class="error-container">
          <p class="error-message">{{ error$ | async }}</p>
        </div>
      } @else {
        <div class="table-wrapper">
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z2">
            <!-- ID Column -->
            <ng-container matColumnDef="rangoSalarialId">
              <th mat-header-cell *matHeaderCellDef>{{ labels.tableId }}</th>
              <td mat-cell *matCellDef="let rangoSalarial">
                {{ rangoSalarial.rangoSalarialId }}
              </td>
            </ng-container>

            <!-- Perfil Column -->
            <ng-container matColumnDef="perfil">
              <th mat-header-cell *matHeaderCellDef>{{ labels.tablePerfil }}</th>
              <td mat-cell *matCellDef="let rangoSalarial">
                {{ rangoSalarial.perfilNombre || 'Perfil ' + rangoSalarial.perfilId }}
              </td>
            </ng-container>

            <!-- Año Column -->
            <ng-container matColumnDef="ano">
              <th mat-header-cell *matHeaderCellDef>{{ labels.tableAno }}</th>
              <td mat-cell *matCellDef="let rangoSalarial">
                {{ rangoSalarial.ano }}
              </td>
            </ng-container>

            <!-- Mínimo Column -->
            <ng-container matColumnDef="minimo">
              <th mat-header-cell *matHeaderCellDef>{{ labels.tableMinimo }}</th>
              <td mat-cell *matCellDef="let rangoSalarial">
                {{ formatCurrency(rangoSalarial.minimo) }}
              </td>
            </ng-container>

            <!-- Máximo Column -->
            <ng-container matColumnDef="maximo">
              <th mat-header-cell *matHeaderCellDef>{{ labels.tableMaximo }}</th>
              <td mat-cell *matCellDef="let rangoSalarial">
                {{ formatCurrency(rangoSalarial.maximo) }}
              </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>{{ labels.tableActions }}</th>
              <td mat-cell *matCellDef="let rangoSalarial">
                <div class="action-buttons">
                  <button
                    mat-icon-button
                    color="primary"
                    (click)="openCreateModal(rangoSalarial)"
                    matTooltip="Editar"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              [class.selected-row]="selectedRangoSalarial?.rangoSalarialId === row.rangoSalarialId"
            ></tr>
          </table>

          @if (dataSource.data.length === 0) {
            <div class="no-data-container">
              <mat-icon class="no-data-icon">inbox</mat-icon>
              <p class="no-data-message">No hay rangos salariales disponibles</p>
              <p class="no-data-submessage">
                Haga clic en "Crear Rango Salarial" para agregar el primero
              </p>
            </div>
          }

          <mat-paginator
            #paginator
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            [showFirstLastButtons]="true"
            (page)="onPageChange($event)"
            aria-label="Seleccionar página de rangos salariales"
          ></mat-paginator>
        </div>
      }
    </div>
  </mat-card>
</div>

<!-- Create/Edit Modal -->
<ng-template #createRangoSalarialModal>
  <h2 id="rango-salarial-modal-title" mat-dialog-title>
    {{ isEditing ? labels.editRangoSalarialPerfil : labels.createRangoSalarialPerfil }}
  </h2>

  <mat-dialog-content id="rango-salarial-modal-content" class="modal-content">
    <form id="rango-salarial-form" [formGroup]="rangoSalarialForm">
      @if (isEditing && editingRangoSalarial) {
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ labels.rangoSalarialId }}</mat-label>
          <input matInput [value]="editingRangoSalarial.rangoSalarialId" readonly />
          <mat-icon matSuffix>lock</mat-icon>
        </mat-form-field>
      }

      <!-- Perfil Field -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ labels.selectPerfil }}</mat-label>
        <mat-select formControlName="perfilId" [class.error-field]="hasError('perfilId')">
          <mat-option [value]="null">{{ labels.notSelected }}</mat-option>
          @for (perfil of perfiles$ | async; track perfil.perfilId) {
            <mat-option [value]="perfil.perfilId">{{ perfil.nombrePerfil }}</mat-option>
          }
        </mat-select>
        @if (hasError('perfilId')) {
          <mat-error>{{ getErrorMessage('perfilId') }}</mat-error>
        }
      </mat-form-field>

      <!-- Ano Field -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ labels.ano }}</mat-label>
        <input
          matInput
          type="number"
          formControlName="ano"
          placeholder="Ej: 2024"
          [class.error-field]="hasError('ano')"
        />
        @if (hasError('ano')) {
          <mat-error>{{ getErrorMessage('ano') }}</mat-error>
        }
      </mat-form-field>

      <!-- Mínimo Field -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ labels.minimo }}</mat-label>
        <input
          matInput
          type="number"
          formControlName="minimo"
          placeholder="Ej: 3000000"
          [class.error-field]="hasError('minimo')"
        />
        @if (hasError('minimo')) {
          <mat-error>{{ getErrorMessage('minimo') }}</mat-error>
        }
      </mat-form-field>

      <!-- Máximo Field -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ labels.maximo }}</mat-label>
        <input
          matInput
          type="number"
          formControlName="maximo"
          placeholder="Ej: 5000000"
          [class.error-field]="hasError('maximo')"
        />
        @if (hasError('maximo')) {
          <mat-error>{{ getErrorMessage('maximo') }}</mat-error>
        }
      </mat-form-field>

      @if (getFormError()) {
        <div class="form-error">
          <mat-icon>error</mat-icon>
          <span>{{ getFormError() }}</span>
        </div>
      }
    </form>
  </mat-dialog-content>

  <mat-dialog-actions id="rango-salarial-modal-actions" align="end">
    <button
      id="save-rango-salarial-button"
      mat-button
      mat-raised-button
      color="primary"
      [disabled]="rangoSalarialForm.invalid"
      [ngClass]="{ 'custom-save-button': rangoSalarialForm.valid }"
      (click)="saveRangoSalarial()"
    >
      {{ labels.save }}
    </button>
    <button id="cancel-rango-salarial-button" mat-button (click)="closeModal()">
      {{ labels.cancel }}
    </button>
  </mat-dialog-actions>
</ng-template>
